import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import StoreGrid from "../components/storegrid"
import { FilterProducts } from "../helpers/product-filter"

const CosyHampers = () => (
	<Layout>
		<SEO title="Cosy Hampers" />

		<div className="homepageBlurb">
			<h1>Cosy Hampers</h1>
			<p>Our bestselling hampers, these cosy gifts feature lots of different animal characters, designs and colours for you to select from! 
				<br/ ><br />Each hamper contains a baby comforter for the little one to make friends and snuggle up with, a super soft blanket to keep baby tucked up warm anytime of the year and a choice of accessories to match. We have Pom Pom Baby Hats, Baby Mittens and Baby Booties to help make this a snuggly baby box and a perfect gift for a new baby arrival.
			</p>
		</div>
		
		<StoreGrid products={FilterProducts("cosy-hampers")} />
	</Layout>
)

export default CosyHampers
